<p-toast></p-toast>

<div class="public-page">
    <div class="approval-detail">
        <div class="public-brand">
            <img src="assets/logos/logo.png" alt="" />
            Comunidad Avalanz
        </div>

        <div *ngIf="loading" class="flex justify-content-center align-items-center py-8">
            <p-progressSpinner strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
        </div>

        <!-- Enlace inválido -->
        <section *ngIf="!loading && error" class="panel state-panel" data-tone="rejected">
            <p class="status-line"><span class="status-dot"></span>Enlace no válido</p>
            <h1 class="detail-title">No pudimos abrir la solicitud</h1>
            <p>{{ error }}</p>
            <p>Esto puede deberse a que:</p>
            <ul>
                <li>El enlace expiró</li>
                <li>El enlace ya se utilizó</li>
                <li>El enlace no es válido</li>
            </ul>
        </section>

        <!-- Enlace válido pero ya utilizado: no se carga la solicitud -->
        <section *ngIf="!loading && success && linkDetails?.used && !reduction" class="panel state-panel" data-tone="draft">
            <p class="status-line"><span class="status-dot"></span>Enlace utilizado</p>
            <h1 class="detail-title">Esta solicitud ya fue atendida</h1>
            <p>El enlace de autorización es de un solo uso. Si necesitas revisar la solicitud, entra a Comunidad Avalanz.</p>
        </section>

        <ng-container *ngIf="!loading && success && reduction">
            <header class="detail-header" [attr.data-tone]="getStatusTone(reduction.status?.code)">
                <div class="min-w-0">
                    <p class="status-line">
                        <span class="status-dot"></span>{{ reduction.status?.name }}
                        <span *ngIf="hasAction('approve') && !linkExpired" class="status-note">· requiere tu aprobación</span>
                    </p>
                    <h1 class="detail-title">Baja de personal</h1>
                    <p class="detail-subtitle">
                        <span *ngIf="reduction.code" class="code">{{ reduction.code }}</span>
                        <span *ngIf="reduction.createdOn">Creada el {{ reduction.createdOn | date : "d 'de' MMMM 'de' y" }}</span>
                    </p>
                </div>

                <div class="detail-actions">
                    <p-button
                        *ngIf="hasAction('reject')"
                        label="Rechazar"
                        icon="pi pi-times"
                        styleClass="p-button-outlined p-button-danger"
                        [disabled]="linkExpired"
                        (onClick)="rejectReduction()"></p-button>
                    <p-button
                        *ngIf="hasAction('approve')"
                        label="Aprobar"
                        icon="pi pi-check"
                        [disabled]="linkExpired"
                        (onClick)="approveReduction()"></p-button>
                </div>
            </header>

            <app-link-expiration
                *ngIf="expirationDate"
                [expirationDate]="expirationDate"
                (expirationStatusChanged)="onExpirationStatusChanged($event)"></app-link-expiration>

            <div class="detail-layout">
                <main class="detail-main">
                    <!-- Colaborador -->
                    <section class="panel">
                        <div class="person-head">
                            <p-avatar shape="circle" size="large" [label]="initials(reduction.employeeName)"></p-avatar>
                            <div class="min-w-0">
                                <div class="person-head-name">{{ reduction.employeeName }}</div>
                                <div class="person-head-meta">
                                    <span class="company-dot" [style.background-color]="getCompanyColor(reduction.company)"></span>
                                    {{ reduction.employeeCompany }}
                                </div>
                            </div>
                        </div>

                        <dl class="facts">
                            <div class="fact-row">
                                <dt>No. de empleado</dt>
                                <dd>{{ reduction.employeeEnrollment || '—' }}</dd>
                            </div>
                            <div class="fact-row">
                                <dt>Departamento</dt>
                                <dd>{{ reduction.employeeDepartmentRelation?.name || reduction.employeeDepartment || '—' }}</dd>
                            </div>
                            <div class="fact-row" *ngIf="reduction.employeeArea">
                                <dt>Área</dt>
                                <dd>{{ reduction.employeeArea }}</dd>
                            </div>
                        </dl>
                    </section>

                    <!-- Detalle de la baja -->
                    <section class="panel">
                        <h2 class="panel-title">Detalle de la baja</h2>
                        <dl class="facts">
                            <div class="fact-row">
                                <dt>Fecha efectiva</dt>
                                <dd>{{ reduction.transactionEffectiveDate | date : "d 'de' MMMM 'de' y" }}</dd>
                            </div>
                            <div class="fact-row">
                                <dt>Tipo de baja</dt>
                                <dd>
                                    <span class="type-chip" [ngClass]="getMovementTypeClass(reduction.movementType)">
                                        {{ getMovementTypeLabel(reduction.movementType) }}
                                    </span>
                                </dd>
                            </div>
                            <div class="fact-row">
                                <dt>Motivo</dt>
                                <dd>{{ reduction.reason || '—' }}</dd>
                            </div>
                        </dl>
                    </section>

                    <!-- Activos asignados -->
                    <section class="panel" *ngIf="reduction.activesReductionRequisitions?.length">
                        <h2 class="panel-title">
                            Activos asignados
                            <span class="count">{{ reduction.activesReductionRequisitions.length }}</span>
                        </h2>
                        <ul class="item-list">
                            <li *ngFor="let active of reduction.activesReductionRequisitions">
                                <i class="pi pi-box"></i>
                                <div class="min-w-0">
                                    <div class="font-medium">{{ active.activeResponsibility?.name }}</div>
                                    <div class="text-sm text-color-secondary" *ngIf="active.activeResponsibility?.label">
                                        {{ active.activeResponsibility?.label }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </section>
                </main>

                <aside class="detail-aside">
                    <!-- Cadena de Capital Humano -->
                    <section class="panel" *ngIf="approvalChain.length">
                        <h2 class="panel-title">Cadena de aprobación</h2>
                        <ul class="people">
                            <li *ngFor="let p of approvalChain">
                                <p-avatar
                                    shape="circle"
                                    [image]="p.person?.photoProfileUrl || undefined"
                                    [label]="p.person && !p.person.photoProfileUrl ? initials(fullName(p.person)) : undefined"
                                    [icon]="p.person ? undefined : 'pi pi-user'"></p-avatar>
                                <div class="min-w-0">
                                    <div class="person-name">{{ fullName(p.person) || 'Sin asignar' }}</div>
                                    <div class="person-role">{{ p.role }}</div>
                                </div>
                            </li>
                        </ul>
                    </section>

                    <!-- Historial -->
                    <section class="panel" *ngIf="reduction.requisitionStatusHistories?.length">
                        <h2 class="panel-title">Historial</h2>
                        <ol class="history">
                            <li
                                *ngFor="let entry of reduction.requisitionStatusHistories"
                                [attr.data-tone]="getStatusTone(entry.status?.code)">
                                <span class="history-marker"><i [ngClass]="getStatusIcon(entry.status?.code)"></i></span>
                                <div class="history-body">
                                    <div class="history-status">{{ entry.status?.name }}</div>
                                    <div class="history-meta">
                                        <ng-container *ngIf="entry.changedBy">{{ fullName(entry.changedBy) }} · </ng-container>
                                        {{ entry.createdOn | date : "d MMM y, h:mm a" }}
                                    </div>
                                    <blockquote *ngIf="entry.comments" class="quote">{{ entry.comments }}</blockquote>
                                </div>
                            </li>
                        </ol>
                    </section>
                </aside>
            </div>
        </ng-container>

        <footer class="public-footer">
            ¿Tienes dudas? Escríbenos a <a href="mailto:comunidad@avalanz.com">comunidad&#64;avalanz.com</a>.
        </footer>
    </div>
</div>

<!-- Approve dialog -->
<p-dialog
    [(visible)]="approveDialogVisible"
    header="Aprobar solicitud de baja"
    [modal]="true"
    [style]="{ width: '500px' }"
    [breakpoints]="{ '575px': '95vw' }"
    [draggable]="false"
    [resizable]="false"
>
    <div class="p-fluid">
        <div class="field">
            <label for="approveComments" class="font-medium">Comentarios *</label>
            <textarea
                id="approveComments"
                rows="5"
                class="w-full"
                pInputTextarea
                [(ngModel)]="commentText"
                [ngClass]="{ 'ng-invalid ng-dirty': commentError }"
                placeholder="Añade tus comentarios de aprobación"
            ></textarea>
            <small *ngIf="commentError" class="p-error">El comentario es obligatorio</small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" styleClass="p-button-text p-button-secondary" (onClick)="cancelDialog()"></p-button>
        <p-button icon="pi pi-check" label="Aprobar" [loading]="processingAction" (onClick)="confirmApprove()"></p-button>
    </ng-template>
</p-dialog>

<!-- Reject dialog -->
<p-dialog
    [(visible)]="rejectDialogVisible"
    header="Rechazar solicitud de baja"
    [modal]="true"
    [style]="{ width: '500px' }"
    [breakpoints]="{ '575px': '95vw' }"
    [draggable]="false"
    [resizable]="false"
>
    <div class="p-fluid">
        <div class="field">
            <label for="rejectComments" class="font-medium">Motivo del rechazo *</label>
            <textarea
                id="rejectComments"
                rows="5"
                class="w-full"
                pInputTextarea
                [(ngModel)]="commentText"
                [ngClass]="{ 'ng-invalid ng-dirty': commentError }"
                placeholder="Indica detalladamente el motivo del rechazo"
            ></textarea>
            <small *ngIf="commentError" class="p-error">El motivo es obligatorio</small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" styleClass="p-button-text p-button-secondary" (onClick)="cancelDialog()"></p-button>
        <p-button icon="pi pi-times" label="Rechazar" styleClass="p-button-danger" [loading]="processingAction" (onClick)="confirmReject()"></p-button>
    </ng-template>
</p-dialog>
